import { cyrb128, simpleFastCounter } from '@inkitt/utils-random';

export const getFakeSocialProof = (seriesId: string) => {
  // `cyrb128` and `simpleFastCounter` are deterministic (always the same given the same input)
  // so the fake data for a given series will always be the same.
  const hashed_id = cyrb128(seriesId);
  const offset = simpleFastCounter(hashed_id);

  // Then `offset` gives us random numbers between 0.0 and 1.0 that allow us to
  // generate deterministic variations in the data.
  const chaptersRead = Math.floor(offset() * 5_000) + 15_000;
  const bookmarksSaved = Math.floor((offset() * 0.01 + 0.02) * chaptersRead);
  const shares = Math.floor((offset() * 0.002 + 0.004) * chaptersRead);

  return {
    chaptersRead,
    shares,
    bookmarksSaved,
  };
};

export function getFakeReadsCount(storyId: string, actualReads: number): number {
  const fakeSocialProof = getFakeSocialProof(storyId);
  return Math.max(actualReads, fakeSocialProof.chaptersRead);
}
